// import Page404 from '../containers/Page404'
// import Page500 from '../containers/Page500'
import WillTemplate from '../containers/WillTemplate'



export default {
  path: '/error',
  name: 'Error',
  component: {
    render(c) { return c('router-view') }
  },
  children: [
    // {
    //     path: '404',
    //     name: 'Data Warehouse',
    //     component: Page404
    //   }, {
    //     path: '500',
    //     name: 'Data Warehouse',
    //     component: Page500
    //   },
    {
      path: 'template',
      name: 'Will Template',
      component: WillTemplate
    },
  ]
}



// WEBPACK FOOTER //
// ./src/ErrorPage/route/index.js